export default "__VITE_ASSET__DWyYDAAd__"